import { classTokenFormats } from '../constants/class-token-formats';
import { targetClassesConfig } from '../constants/target-classes';
import handleAliasedClassToken from './class-token-handlers/handle-aliased-class-token';
import handleBracketedClassToken from './class-token-handlers/handle-bracketed-class-token';

const formatOf = (target) => targetClassesConfig[target]?.format;

const HANDLERS = {
  [classTokenFormats.BRACKETED]: handleBracketedClassToken,
  [classTokenFormats.ALIASED]: handleAliasedClassToken,
};

const getHandler = (target) => HANDLERS[formatOf(target)] ?? HANDLERS[classTokenFormats.BRACKETED];

const serializeClassToken = (target, value) => getHandler(target).serialize(target, value);

const matchesClassTarget = (target, body) => getHandler(target).matches(target, body);

const parseClassToken = (target, body) => getHandler(target).parse(target, body);

const findTargetForToken = (body, targets) =>
  targets.find((target) => matchesClassTarget(target, body)) || null;

const readClassValues = ({ element, target }) => getHandler(target).readValues({ element, target });

const patchClass = ({ currentClass, target, value, breakpointKey }) =>
  getHandler(target).patch({ currentClass, target, value, breakpointKey });

const removeClass = ({ currentClass, target, breakpointKey }) =>
  getHandler(target).remove({ currentClass, target, breakpointKey });

export {
  serializeClassToken,
  parseClassToken,
  matchesClassTarget,
  findTargetForToken,
  readClassValues,
  patchClass,
  removeClass,
};
